export default __webpack_public_path__ + "static/media/step4.7d02c08d.webp";